import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  TProductPriceHistory,
  TProductPriceHistoryForm,
} from "../types/productPriceHistory.types";
import productPriceHistoryApi from "../services/productPriceHistory.api";
import { useIsAuth } from "../../../utils/useAuth";
import {
  errorNotification,
  successNotification,
} from "../../../utils/notification";
import {
  PRODUCT_PRICE_HISTORY_MESSAGES_ERROR,
  PRODUCT_PRICE_HISTORY_MESSAGES_SUCCESS,
} from "../constants/messages";
import { ApiResponse } from "../../../interfaces/apiResponseInterface";

export const useSaveProductPriceHistoryMutation = () => {
  const queryClient = useQueryClient();
  const { userData } = useIsAuth();

  return useMutation<
    ApiResponse<TProductPriceHistory>,
    Error,
    TProductPriceHistoryForm
  >({
    mutationFn: async (productPriceHistory) => {
      const productPriceHistoryWithUser: TProductPriceHistoryForm = {
        ...productPriceHistory,
        updatedBy:
          productPriceHistory._id && userData?.userId
            ? userData.userId
            : undefined,
      };
      return productPriceHistoryApi.saveProductPriceHistory(
        productPriceHistoryWithUser,
      );
    },
    onSuccess: (res, producPriceHistory) => {
      if (!res.ok) {
        errorNotification(PRODUCT_PRICE_HISTORY_MESSAGES_ERROR.SAVE_ERROR);
        return;
      }
      successNotification(PRODUCT_PRICE_HISTORY_MESSAGES_SUCCESS.SAVE_SUCCESS);
      queryClient.invalidateQueries({
        queryKey: ["product-price-histories"],
      });
      if (producPriceHistory._id) {
        queryClient.invalidateQueries({
          queryKey: ["product-price-history", producPriceHistory._id],
        });
      }
    },
    onError: (error: Error) => {
      errorNotification(PRODUCT_PRICE_HISTORY_MESSAGES_ERROR.SAVE_ERROR);
    },
  });
};
